export const GET_ALL_LOOKUPS_SUCCESS =
  'CBRE-FLOW-LAB-ENTITLEMENT-MAKE-DECISION/GET_ALL_LOOKUPS_SUCCESS';
export const GET_ALL_LOOKUPS_FAILURE =
  'CBRE-FLOW-LAB-ENTITLEMENT-MAKE-DECISION/GET_ALL_LOOKUPS_FAILURE';
export const MODULE = 'cbre-flow-lab-entitlement-reviewer-make-decision';

export const REVIEWER_DECISION = 'CBRE-FLOW-LAB-ENTITLEMENT-MAKE-DECISION/REVIEWER_DECISION';